import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import TextField from "@material-ui/core/TextField";

const getLocalizedSeparators = (thousandSeparator) => (
    navigator.language.indexOf('de') > -1
        ? {decimalSeparator: ',', thousandSeparator: (thousandSeparator === false ? false : '.') }
        : {thousandSeparator: thousandSeparator || true /* use default */}
);

const NumberFormatCustom = (props) => {
    const {value, inputRef, onChange, thousandSeparator, ...other} = props;

    return (
        <NumberFormat
            {...other}
            {...getLocalizedSeparators(thousandSeparator)}
            defaultValue={value} // do not bind as "value" !
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        id: other.id,
                        name: other.name,
                        value: values.floatValue,
                    },
                });
            }}
        />
    );
};

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    fixedDecimalScale: PropTypes.bool,
    decimalScale: PropTypes.number,
};

NumberFormatCustom.defaultProps = {
    fixedDecimalScale: true,
    decimalScale: 2,
};

const FormNumber = ({label, name, error, label_exclaim, touched, onChange, onBlur, ...props}) => {

    const {
        // Number format props.
        fixedDecimalScale,
        decimalScale,
        format,
        mask,
        thousandSeparator,

        // Gather the rest.
        ...other
    } = props;

    return (
        <TextField
            id={name}
            name={name}
            label={label}
            placeholder={label}
            onChange={onChange}
            onBlur={onBlur}
            error={touched && !!error}
            helperText={(touched && error) || label_exclaim}
            InputProps={{
                // Applied to the MUI Input element
                inputComponent: NumberFormatCustom,
            }}
            inputProps={{
                // Applied to the native input element
                // thus its applied to our NumberFormatCustom component
                fixedDecimalScale,
                decimalScale,
                format,
                mask,
                thousandSeparator,
            }}
            {...other}
        />
    );
};

FormNumber.defaultProps = {
    fullWidth: true,
};

export default FormNumber;
